import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import isEmpty from 'lodash/isEmpty';
import { di } from 'react-magnetic-di';
import { fireOperationalEvent } from '@atlassian/ui-modifications-analytics';
import { LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY, LOOKUP_SOURCE_USERS_ASYNC_DATA } from '../../../../common/constants';
import { UiModificationsFieldsValidationError } from '../../utils/errors/ui-modifications-field-validation-error';
import { fieldWasRegistered } from '../../utils/field-was-registered';
import { mapFieldPropertyNamesToInternal as mapFieldPropsFromPublicToInternalShape } from '../../utils/map-field-props-from-public-to-internal-shape';
import { prepareErrorsArray } from '../../utils/prepare-errors-array';
import { transformFieldToIframe } from '../../utils/supported-field-properties';
import { addAppsErrors } from '../app-errors';
import { collectFieldsAppliedChangesHistory } from '../applied-changes-history/collect-history';
import { transformFieldChangesToInternalShape } from './transform-field-changes-to-internal-shape';
/**
 * Updates fields with the provided changes.
 */
export var updateFields = function updateFields(_ref) {
  var changeId = _ref.changeId,
    fieldsChanges = _ref.fieldsChanges,
    lookupDataFromApi = _ref.lookupDataFromApi,
    tenantContext = _ref.tenantContext,
    executionContext = _ref.executionContext,
    environment = _ref.environment,
    appId = _ref.appId,
    intl = _ref.intl,
    createAnalyticsEvent = _ref.createAnalyticsEvent;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, _ref3) {
      var _getState$appliedChan, _getState$formData;
      var setState, getState, dispatch, viewType, appliedChanges, formData, _getState, internalFormMetadata, registeredFields, _yield$Object$keys$re, changesToApply, incomingFormData, errorsByField, newAppliedChangesPublic;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setState = _ref2.setState, getState = _ref2.getState, dispatch = _ref2.dispatch;
            viewType = _ref3.viewType;
            appliedChanges = (_getState$appliedChan = getState().appliedChanges) !== null && _getState$appliedChan !== void 0 ? _getState$appliedChan : {};
            formData = (_getState$formData = getState().formData) !== null && _getState$formData !== void 0 ? _getState$formData : {};
            _getState = getState(), internalFormMetadata = _getState.internalFormMetadata, registeredFields = _getState.registeredFields;
            _context2.next = 7;
            return Object.keys(fieldsChanges).reduce( /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(acc, fieldId) {
                var fieldData, internalMetadata, fieldIsRegistered, _ref6, fieldType, lookupData, supportedFieldChanges, publicShapeChanges, transformedFieldChanges, combinedChangesToApply;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      // Do not update fields that are not inside initialized data.
                      // Validates if the field that comes from Iframe is supported
                      // - because we add to formData only the supported ones.
                      fieldData = formData[fieldId];
                      internalMetadata = internalFormMetadata[fieldId];
                      fieldIsRegistered = fieldWasRegistered(registeredFields, changeId, fieldId, appId); // Only registered field Ids can be updated.
                      if (!(!fieldIsRegistered || !fieldData)) {
                        _context.next = 8;
                        break;
                      }
                      _ref6 = fieldData !== null && fieldData !== void 0 ? fieldData : {}, fieldType = _ref6.fieldType;
                      dispatch(addAppsErrors({
                        errors: _defineProperty({}, appId, [{
                          fieldType: fieldType,
                          fieldId: fieldId,
                          type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                          message: 'Application tried to apply changes to unregistered field'
                        }])
                      }));
                      fireOperationalEvent(createAnalyticsEvent, {
                        action: 'unregisteredField',
                        actionSubject: 'jiraUiModifications.applyChanges',
                        attributes: {
                          message: 'Attempt to apply changes to a field that was not registered',
                          fieldId: fieldId,
                          viewType: viewType
                        }
                      });
                      return _context.abrupt("return", acc);
                    case 8:
                      lookupData = _defineProperty(_defineProperty({}, LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY, internalMetadata.allowedValues), LOOKUP_SOURCE_USERS_ASYNC_DATA, lookupDataFromApi[LOOKUP_SOURCE_USERS_ASYNC_DATA]); // It updates properties in each field to avoid removing unchanged props for
                      // selected field by another app or another onChange update.
                      // Only supported properties are allowed.
                      _context.next = 11;
                      return transformFieldChangesToInternalShape({
                        fieldType: fieldData.fieldType,
                        fieldId: fieldId,
                        fieldFromIframe: fieldsChanges === null || fieldsChanges === void 0 ? void 0 : fieldsChanges[fieldId],
                        lookupData: lookupData,
                        viewType: viewType,
                        tenantContext: tenantContext,
                        executionContext: executionContext,
                        environment: environment,
                        intl: intl
                      });
                    case 11:
                      supportedFieldChanges = _context.sent;
                      if (!(supportedFieldChanges.isValid === false)) {
                        _context.next = 18;
                        break;
                      }
                      _context.next = 15;
                      return acc;
                    case 15:
                      _context.t0 = fieldId;
                      _context.sent.errorsByField[_context.t0] = supportedFieldChanges.errors;
                      return _context.abrupt("return", acc);
                    case 18:
                      // It converts changes to 'public' format to update the formData
                      publicShapeChanges = transformFieldToIframe(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges === null || fieldsChanges === void 0 ? void 0 : fieldsChanges[fieldId], internalMetadata);
                      transformedFieldChanges = mapFieldPropsFromPublicToInternalShape(supportedFieldChanges.data, viewType, fieldData.fieldType);
                      combinedChangesToApply = _objectSpread(_objectSpread({}, appliedChanges[fieldId]), transformedFieldChanges);
                      if (isEmpty(combinedChangesToApply)) {
                        _context.next = 34;
                        break;
                      }
                      _context.next = 24;
                      return acc;
                    case 24:
                      _context.t1 = fieldId;
                      _context.sent.newAppliedChangesPublic[_context.t1] = publicShapeChanges;
                      _context.next = 28;
                      return acc;
                    case 28:
                      _context.t2 = fieldId;
                      _context.sent.changesToApply[_context.t2] = combinedChangesToApply;
                      _context.next = 32;
                      return acc;
                    case 32:
                      _context.t3 = fieldId;
                      _context.sent.incomingFormData[_context.t3] = _objectSpread(_objectSpread({}, formData[fieldId]), publicShapeChanges);
                    case 34:
                      return _context.abrupt("return", acc);
                    case 35:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x3, _x4) {
                return _ref5.apply(this, arguments);
              };
            }(), Promise.resolve({
              changesToApply: _objectSpread({}, appliedChanges),
              incomingFormData: _objectSpread({}, formData),
              newAppliedChangesPublic: {},
              errorsByField: {}
            }));
          case 7:
            _yield$Object$keys$re = _context2.sent;
            changesToApply = _yield$Object$keys$re.changesToApply;
            incomingFormData = _yield$Object$keys$re.incomingFormData;
            errorsByField = _yield$Object$keys$re.errorsByField;
            newAppliedChangesPublic = _yield$Object$keys$re.newAppliedChangesPublic;
            if (isEmpty(errorsByField)) {
              _context2.next = 14;
              break;
            }
            throw new UiModificationsFieldsValidationError('Transformation failed', {
              errors: prepareErrorsArray(errorsByField)
            });
          case 14:
            setState({
              appliedChanges: changesToApply,
              formData: incomingFormData
            });
            dispatch(collectFieldsAppliedChangesHistory({
              appId: appId,
              changeId: changeId,
              fieldsChanges: newAppliedChangesPublic
            }));
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};